import { render, staticRenderFns } from "./UserToolbarInfo.vue?vue&type=template&id=0c4efd64&scoped=true&"
import script from "./UserToolbarInfo.vue?vue&type=script&lang=js&"
export * from "./UserToolbarInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4efd64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
